import { apiServer } from "../config/config";
import { SyncBusinessRespose } from "../types";
import { fetchWithToken } from "./fetchWithToken";
import { NearbyBusinessesResponse } from "../types/nearby-businesses";
import { BusinessInterestType } from "../types/tagging";

export async function fetchBusinessTypes() {
  return await fetch(apiServer + "/business/load-business-types");
}

export async function fetchBusinessTypesFrontend() {
  return await fetch(apiServer + "/business/load-business-types-frontend");
}

export async function addMapperNotes(
  venueId: string,
  notes: string,
  businessReportIssueAction: string,
  token: string,
  returnOnDate?: string,
  actionOnDate?: string,
  locationDetails?: Array<{ location_type: string; location_id: string }>
) {
  try {
    const formData = new FormData();
    formData.append("business_id", venueId);
    formData.append("notes", notes);

    // Use locationDetails array if provided, otherwise fall back to single location
    if (locationDetails && locationDetails.length > 0) {
      locationDetails.forEach((location, index) => {
        formData.append(
          `location_details[${index}][location_type]`,
          location.location_type
        );
        formData.append(
          `location_details[${index}][location_id]`,
          location.location_id
        );
      });
    }

    formData.append("businessReportIssueAction", businessReportIssueAction);
    if (returnOnDate) {
      formData.append("return_on_date", returnOnDate);
    }
    if (actionOnDate) {
      formData.append("action_on_date", actionOnDate);
    }
    console.log(formData);
    const response = await fetch(`${apiServer + "/review/report-venue"}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    });
    const data = await response.json();
    console.log(data);
    if (data.status === "error") {
      return data.message;
    } else {
      return data.data;
    }
  } catch (error: any) {
    return error.message;
  }
}

export async function closeMapperNote(issueId: string, accessToken: string) {
  try {
    const formData = new FormData();
    formData.append("issueId", issueId);
    const response = await fetch(
      `${apiServer + "/business/close-mapper-note"}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        body: formData,
      }
    );
    const data = await response.json();
    if (data.status === "error") {
      return data.message;
    } else {
      return data;
    }
  } catch (error: any) {
    console.log(`closeMapperNote error: ${error}`);
    return error.message;
  }
}

export async function syncBusiness(businessId: string, accessToken: string) {
  const formData = new FormData();
  formData.append("business_id", businessId);
  const response = await fetchWithToken(apiServer + "/business/sync-business", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  const data = await response?.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data as {
    status: string;
    message: string;
    data: SyncBusinessRespose;
  };
}

export async function fetchNearbyBusinesses(
  businessId: string
): Promise<NearbyBusinessesResponse> {
  const formData = new FormData();
  formData.append("business_id", businessId);

  const response = await fetch(
    `${apiServer}/business/near-by-businesses-details`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}

export async function addClaims(
  venueId: string,
  name: string,
  email: string,
  phone: string,
  description: string,
  flagVenueAccessibilityId: string | null,
  token: string
) {
  try {
    const formData = new FormData();
    formData.append("business_id", venueId);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("description", description);
    if (flagVenueAccessibilityId) {
      formData.append("flag_venue_accessibility_id", flagVenueAccessibilityId);
    }

    console.log(formData);
    const response = await fetch(
      `${apiServer + "/business/create-business-claim"}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      }
    );
    const data = await response.json();
    return data;
  } catch (error: any) {
    return error.message;
  }
}

export async function loadBusinessInterests(token: string, includePhotos: boolean = true) {
  const queryParams = new URLSearchParams({
    sort_by: "created_at",
    sort_order: "desc",
    include_photos: includePhotos.toString(),
  });

  // Adding query parameters to the URL
  const url = `${apiServer}/user/business-interests?${queryParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    const data = await response.json();
    return data as {
      status: string;
      message: string;
      data: BusinessInterestType[];
    };
  } catch (error: any) {
    console.log(`loadBusinessInterests error: ${error}`);
    return {
      status: "error",
      message: error.message,
      data: [],
    };
  }
}

export async function syncBusinessInterests(
  businessId: string,
  interestType: string,
  notifyAccessibilityInformation: boolean,
  notifyLiveAlert: boolean,
  token: string,
  action: "create" | "update" | "delete",
  interestId?: string
) {
  try {
    const formData = new FormData();
    formData.append("business_id", businessId);
    formData.append("interested_type", interestType);
    formData.append(
      "notify_accessibility_information",
      notifyAccessibilityInformation ? "1" : "0"
    );
    formData.append("notify_live_alert", notifyLiveAlert ? "1" : "0");
    if (interestId) {
      formData.append("id", interestId);
    }
    formData.append("action", action);
    console.log(formData);
    const response = await fetch(`${apiServer}/business/sync-subscription`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    });
    const data = await response.json();
    console.log(JSON.stringify(data));
    return data;
  } catch (error: any) {
    return error.message;
  }
}
